if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const idInput = this.form.querySelector('input[name="id"]');
        const colorFieldset = document.querySelector('variant-radios fieldset.product-form__input-color') ||
                              Array.from(document.querySelectorAll('variant-radios fieldset')).find(fs => {
                                const leg = fs.querySelector('legend');
                                return leg && leg.textContent.toLowerCase().includes('color');
                              });

        if (colorFieldset) {
          const checkedRadio = colorFieldset.querySelector('input[type="radio"]:checked');
          if (!checkedRadio || !idInput || !idInput.value) {
            const errorMsg = 'Please select a color first.';
            const inlineError = colorFieldset.querySelector('.color-selection-error') || document.querySelector('.color-selection-error');
            if (inlineError) {
              inlineError.style.display = 'flex';
              const textSpan = inlineError.querySelector('.color-selection-error-text');
              if (textSpan) textSpan.textContent = errorMsg;
            }
            colorFieldset.classList.add('has-error');
            this.handleErrorMessage(errorMsg);
            colorFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
                fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
